var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17428_185008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0803 25.4416C28.6165 26.513 28.0676 27.4992 27.4315 28.4059C26.5646 29.642 25.8547 30.4977 25.3077 30.9728C24.4596 31.7527 23.551 32.1521 22.578 32.1748C21.8795 32.1748 21.0372 31.976 20.0566 31.5728C19.0729 31.1715 18.1688 30.9728 17.3421 30.9728C16.4752 30.9728 15.5453 31.1715 14.5508 31.5728C13.5547 31.976 12.7523 32.1862 12.1388 32.207C11.2058 32.2467 10.2758 31.836 9.34746 30.9728C8.75497 30.456 8.01388 29.5701 7.12609 28.3151C6.17356 26.9749 5.39045 25.4208 4.77694 23.649C4.1199 21.7352 3.79053 19.882 3.79053 18.0879C3.79053 16.0327 4.23461 14.2602 5.12411 12.7748C5.82317 11.5816 6.75318 10.6405 7.91715 9.94954C9.08112 9.25862 10.3388 8.90653 11.6932 8.884C12.4343 8.884 13.4061 9.11324 14.6138 9.56376C15.8181 10.0158 16.5914 10.245 16.9304 10.245C17.1839 10.245 18.0429 9.97699 19.4991 9.44261C20.8763 8.94704 22.0385 8.74184 22.9907 8.82267C25.5708 9.0309 27.5091 10.048 28.7982 11.8803C26.4907 13.2785 25.3493 15.2367 25.372 17.7489C25.3928 19.7056 26.1027 21.3339 27.4978 22.6268C28.13 23.2268 28.8361 23.6906 29.6217 24.02C29.4513 24.514 29.2715 24.9873 29.0803 25.4416V25.4416ZM23.1629 2.15648C23.1629 3.69016 22.6026 5.12215 21.4858 6.44759C20.138 8.02328 18.5078 8.93379 16.74 8.79011C16.7175 8.60612 16.7044 8.41247 16.7044 8.20898C16.7044 6.73665 17.3453 5.16096 18.4836 3.87262C19.0518 3.22031 19.7746 2.67793 20.651 2.24525C21.5255 1.81904 22.3528 1.58333 23.1308 1.54297C23.1535 1.748 23.1629 1.95304 23.1629 2.15646V2.15648Z",
    fill: "#1E1850"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17428_185008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.706055 0.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.0f30feec1b00f690119302124d57ade5.svg";
export { ForwardRef as ReactComponent };